import { gsap } from "gsap/dist/gsap";

export default function valueStepAnimation(valueStepTl) {
  const valueStepCardArray = gsap.utils.toArray(".valeurs--step-card");
  valueStepTl.from(valueStepCardArray, {
    stagger: 0.2,
    opacity: 0,
    scale: 0,
    duration: 0.3,
  });
}
